/**
 * Cookie Consent Manager Component
 * Main component that manages the cookie consent banner and preference center
 */

import React, { useState } from 'react';
import CookieConsentBanner from './CookieConsentBanner';
import CookiePreferenceCenter from './CookiePreferenceCenter';

const CookieConsentManager: React.FC = () => {
  const [preferenceCenterOpen, setPreferenceCenterOpen] = useState(false);

  return (
    <>
      <CookieConsentBanner />
      <CookiePreferenceCenter
        open={preferenceCenterOpen}
        onClose={() => setPreferenceCenterOpen(false)}
      />
    </>
  );
};

/**
 * Hook to open the cookie preference center
 * Useful for adding a "Cookie Preferences" link in footer
 */
export const useCookiePreferences = () => {
  const [open, setOpen] = useState(false);

  const openPreferences = () => setOpen(true);
  const closePreferences = () => setOpen(false);

  return {
    openPreferences,
    PreferenceCenter: () => (
      <CookiePreferenceCenter open={open} onClose={closePreferences} />
    ),
  };
};

export default CookieConsentManager;
